import React from 'react';
import { ApButtonText } from '@alixpartners/ui-components';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';

import { useTableData } from './TopSpendItemsTable.helpers';
import { Pagination, TableWrapper } from '../Table.styles';
import { TableHeader, TableHeaderGroup } from '../TableComponents';
import { ICurrencyFormat } from 'utils/types';
import { HEADER_HEIGHT, ROW_HEIGHT } from '../table-utils';
import { GridReadyEvent } from 'ag-grid-community';

export const TopSpendItems = ({
  format,
  rowData,
  columnDateLabels,
  pageSize = 10,
}: {
  format: ICurrencyFormat;
  rowData: Array<{
    [x: string]: string | number | undefined | null;
  }>;
  columnDateLabels: string[];
  pageSize?: number;
}) => {
  const [gridApi, setGridApi] = React.useState<any>(null);
  const [extraRows, setExtraRows] = React.useState(0);
  const { columnDefs } = useTableData(columnDateLabels, format);
  const paginationPageSize = pageSize * (extraRows + 1);
  const gridOptions = {
    columnDefs,
    defaultColDef: { width: 54 },
    rowData,
    rowHeight: ROW_HEIGHT,
    headerHeight: HEADER_HEIGHT,
  };
  return (
    <div>
      <TableWrapper className="ag-theme-balham">
        <AgGridReact
          {...gridOptions}
          frameworkComponents={{
            customHeaderGroupComponent: TableHeaderGroup,
            agColumnHeader: TableHeader,
          }}
          onGridReady={(event: GridReadyEvent) => {
            setGridApi(event.api);
            event.api.paginationSetPageSize(paginationPageSize);
          }}
          suppressCopyRowsToClipboard
          suppressScrollOnNewData
          suppressRowHoverHighlight
          suppressRowDrag
          suppressRowClickSelection
          suppressCellSelection
          suppressCsvExport
          suppressExcelExport
          suppressContextMenu
          domLayout="autoHeight"
          paginationPageSize={paginationPageSize}
          paginationAutoPageSize={true}
          pagination={true}
          suppressPaginationPanel={true}
        />
      </TableWrapper>
      <Pagination>
        {paginationPageSize}/{rowData.length}
        {paginationPageSize !== rowData.length && (
          <ApButtonText
            onClick={() => {
              const currentPageSize = gridApi.paginationGetPageSize();
              gridApi.paginationSetPageSize(currentPageSize + pageSize);
              setExtraRows(extraRows + 1);
            }}
          >
            SHOW MORE...
          </ApButtonText>
        )}
      </Pagination>
    </div>
  );
};

export default TopSpendItems;
